function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "star");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "b1c0bcac-891c-4d40-85d7-ce5a02db3855",
  "data-name": "svg 2",
  d: "M61.93,59.82V90.16l57.58-57.24h29.31l-30-31Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "fa17dbe9-dd2a-43f5-8ca1-a2fec0a22424",
  "data-name": "svg 3",
  d: "M120.42,36.78,99,58.24l81.19.24,20.73,20.73.73-43.16-81.19.73Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "e68ae421-6e61-4367-a366-b5a080509970",
  "data-name": "svg 4",
  d: "M178.29,62.5,148,62.62,205.41,120l.11,29.31,30.92-30.12Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "a5b805ec-ed7e-4323-b481-34346da08ee7",
  "data-name": "svg 5",
  d: "M201.31,122.05l-21.53-21.39,0,81.2-20.65,20.79,43.16.59-1-81.19Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  id: "aa4a6ee4-785c-4da6-8cd3-f0ab81d86874",
  "data-name": "svg 6",
  d: "M175.71,179.28V148.94l-57.61,57.22H88.8l30,31,56.92-57.91Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  id: "f5c7443a-f204-443c-89af-7e4e24e49295",
  "data-name": "svg 7",
  d: "M117.23,201.35l21.43-21.48-81.19-.15L36.72,159,36,202.17Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  id: "a959da59-30c8-4f78-be62-7e01eb54546c",
  "data-name": "svg 8",
  d: "M59.73,175.48l30.35.18L33.19,117.73l.17-29.31L2.15,118.23l57.58,57.25Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  id: "a717977b-a910-4062-a931-840a74afe34e",
  "data-name": "svg 9",
  d: "M37,116.53l21.35,21.56L59,56.9,79.82,36.28l-43.15-1Z",
  transform: "translate(-2.15 -1.89)",
  fill: "#000"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "f2dfb9f9-6fcf-4699-bddb-65620fbefa64",
    "data-name": "Layer 1",
    viewBox: "0 0 234.29 235.3",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.29df3e84.svg";
export { ForwardRef as ReactComponent };